import { render, staticRenderFns } from "./Tts.vue?vue&type=template&id=f600aa44&scoped=true"
import script from "./Tts.vue?vue&type=script&lang=js"
export * from "./Tts.vue?vue&type=script&lang=js"
import style0 from "./Tts.vue?vue&type=style&index=0&id=f600aa44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f600aa44",
  null
  
)

export default component.exports